 export interface ILogisticsView {
    chainId: number;
    clusterNumber: number;
    position: number;
    donorCenter: string;
    donorAlias: string;
    donorSurgeonContact: string;
    recipientCenter: string;
    recipientAlias: string;
    recipientSurgeonContact: string;
    logisticsProvider: string;
    pickupDateTime: string;
    pickupDateTimeBackup: string;
    pickupDateTimeActual: string;
    pickupGroundMiles: string;
    pickupGroundMilesBackup: string;
    pickupGroundMilesActual: string;
    dropoffGroundMiles: string;
    dropoffGroundMilesBackup: string;
    dropoffGroundMilesActual: string;
    arrivalDateTime: string;
    arrivalDateTimeBackup: string;
    arrivalDateTimeActual: string;
    flightRouteOrGround: string;
    flightRouteOrGroundBackup: string;
    flightRouteOrGroundActual: string;
    transportMethod: number;
    transportMethodBackup: number;
    transportMethodActual: number;
    transportCost: string;
    transportCostBackup: string;
    transportCostActual: string;
    flightCarrierAndNumber: string;
    flightCarrierAndNumberBackup: string;
    flightCarrierAndNumberActual: string;
    flightDepartureTime: string;
    flightDepartureTimeBackup: string;
    flightDepartureTimeActual: string;
    flightArrivalTime: string;
    flightArrivalTimeBackup: string;
    flightArrivalTimeActual: string;
    tenderedToAirlineActual: string;
    recoveredFromAirlineActual: string;
    leg2DepartureTime: string;
    leg2DepartureTimeBackup: string;
    leg2DepartureTimeActual: string;
    leg2ArrivalTime: string;
    leg2ArrivalTimeBackup: string;
    leg2ArrivalTimeActual: string;
    deliveryLocation: string;
    deliveredTo: string;
    jobNumber: string;
    earliestPickupTime: string;
    latestDropoffTIme: string;
}
